var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    skjerm: _vm.nextLayerName === 'Skaermkort',
    orto: _vm.nextLayerName === 'Ortho',
    forvaltning: _vm.nextLayerName === 'Forvaltning'
  },on:{"click":_vm.buttonClick}})}
var staticRenderFns = []

export { render, staticRenderFns }